import React from "react";

import Row   from 'react-bootstrap/Row';
import Col   from 'react-bootstrap/Col';

import logo  from "../../assets/innovac-logo-horiz.png";

const Header = () => {
  return (
    <Row style={{margin: "30px 0px"}}>
      <Col md={6}>
        <a href="https://innovac.com.br/"><img src={logo} alt="Innovac Logo" /></a>
      </Col>
      <Col md={6} className="text-end">
        <a href="https://innovac.com.br/" className="btn btn-success btn-portal-verde">
          Voltar ao Site Innovac
        </a>
      </Col>
    </Row>
  );
}
export default Header;